import script from "./ProfileParentRelationship.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileParentRelationship.vue?vue&type=script&lang=ts&setup=true"

import "./ProfileParentRelationship.vue?vue&type=style&index=0&id=aba18b30&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aba18b30"]])

export default __exports__